import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../../../../hooks/authentication/useAuth';
import { useTranslation } from 'react-i18next';

export const LogoutLandingPage = () => {
    const auth = useAuth();
    const { t } = useTranslation();

    if (auth.isLoggedIn) {
        auth.logout();
    } else {
        return (
            <>
                <Navigate to={'/login'} replace />
            </>
        );
    }

    return <>{t('LOGOUT_LANDING')}</>;
};
